import Text from "../../../components/about/text";
import Form from "../../../components/form/Form";
import React from "react";
import { getAbout, updateAbout } from "../../../apis/aboutApi";
import { useState, useEffect } from "react";
import Error from "../../../components/errors-messages/Error";

// import "./NavigationItems.css";

function About(props) {
  const [state, setState] = useState({
    isEditing: false,
    content: "",
    editAbout: null,
    error: null,
  });

  useEffect(() => {
    loadPosts();
    // const socket = openSocket("https://shark-app-2ttko.ondigitalocean.app/website");

    // socket.on("posts", (data) => {
    //   if (data.action === "create") {
    //     addPost(data.post);
    //   } else if (data.action === "update") {
    //     updatePost(data.post);
    //   } else if (data.action === "delete") {
    //     loadPosts();
    //   }
    // });
  }, []);

  const loadPosts = async () => {
    const { data, error } = await getAbout();
    if (!data && error) {
      return setState((prevState) => {
        return {
          isEditing: false,
          content: "",
          editAbout: null,
          error: error,
        };
      });
    }
    setState((prevState) => {
      return {
        ...prevState,
        content: data.about[0].content,
      };
    });
  };

  const startEditPostHandler = (postId) => {
    setState((prevState) => {
      // const loadedPost = { ...prevState.posts.find((p) => p._id === postId) };

      return {
        ...prevState,
        isEditing: true,
        editAbout: { content: prevState.content },
        error: null,
      };
    });
  };

  const cancelEditHandler = () => {
    setState((prevState) => {
      return {
        ...prevState,
        isEditing: false,
        editAbout: "",
        error: null,
      };
    });
  };

  const finishEditHandler = async (aboutData) => {
    setState((prevState) => {
      return {
        ...prevState,
        editLoading: true,
      };
    });
    // Set up data (with image!)

    // let url = "URL";
    // let method = "POST";
    // if (state.editPost) {
    // }

    // const formData = new FormData();

    // formData.append("title", postData.title);
    // formData.append("content", postData.content);
    // formData.append("image", postData.image);

    // console.log("DATA", formData);

    const { data, error } = await updateAbout(props.token, aboutData);

    if (!data && error) {
      return setState((prevState) => {
        return {
          ...prevState,
          isEditing: false,
          editAbout: "",
          // editLoading: false,
          error: error,
        };
      });
    }
    setState((prevState) => {
      return {
        ...prevState,
        content: data.about.content,
        isEditing: false,
        editAbout: "",
        // editLoading: false,
      };
    });
  };

  return (
    <>
      <Error error={state.error} onHandle={cancelEditHandler} />

      <Form
        editing={state.isEditing}
        currentItem={state.editAbout}
        page={"About"}
        // loading={state.editLoading}
        onCancelEdit={cancelEditHandler}
        onFinishEdit={finishEditHandler}
      />
      <Text onStartEdit={startEditPostHandler.bind(this)} isAuth={props.isAuth}>
        {state.content}
      </Text>
    </>
  );
}

export default About;
